import i18n from '../i18n'
import * as translations from './locales';

for(var lng in translations) {
    i18n.addResourceBundle(lng, 'actionbar', translations[lng])
}

export default i18n
